<template>
    <div>
        <v-toolbar class="toolbar-header-color">
            <v-toolbar-title>
                {{$t('expenses_budget_report')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn dark text @click="dialogueClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-form>
            <v-row>

                <v-card class="pa-4 mx-3" id="form_card" width="100%">
                    <v-row>
                        <v-col class="col-4">
                            <v-autocomplete :error-messages="yearErrors"
                                            :items="yearList"
                                            item-text="id" dense outlined
                                            item-value="value"
                                            :label="$t('select_year')"
                                            required
                                            v-model="logData.year">
                            </v-autocomplete>
                        </v-col>
                        <v-col class="col-4">
                            <v-autocomplete :items="roleReportList"
                                            item-text="value" dense outlined
                                            item-value="id"
                                            :label="$t('reports')"
                                            required
                                            v-model="logData.reportID">
                            </v-autocomplete>
                        </v-col>
                        <v-col class="col-2">
                        </v-col>
                        <v-col class="col-2">
                            <v-btn @click="LoadBudgetExpensesData()" class="ml-2" color="green" dark>
                                {{$t('search')}}
                            </v-btn>
                            <v-btn @click="reset" class="ml-2" color="blue darken-4" dark> {{$t('reset')}}</v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-row>
        </v-form>
        <br />
        <v-container>
            <v-timeline :dense="$vuetify.breakpoint.smAndDown" v-for="(report, index) in expensesReport" :key="report.officeBudgetExpenseID">
                <v-timeline-item v-if="index % 2 === 0"
                                 :color="index % 2 === 0 ? 'purple lighten-2' : 'blue lighten-2'"
                                 style="padding-bottom:0px;padding-top:0px"
                                 right>
                    <v-card class="custom-design">
                        <v-card-title class="custom-title" :style="getSubjectRowStyle(index)">
                            <span>  {{index+1}}</span>
                            <v-icon dark
                                    size="42"
                                    class="mr-4">
                                mdi-calendar-text
                            </v-icon>
                            <h2 class="text-h6 white--text font-weight-bold">
                                {{report.monthName}}  [ {{report.subsectionName}} ]
                            </h2>
                        </v-card-title>
                        <v-container :style="{ backgroundColor: report.colorCode }">

                            <v-row class="font-weight-bold">
                                <v-col cols="12">
                                    <v-icon size="22">mdi-pencil</v-icon>
                                    {{ report.remarks }}
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="6" md="6" class="text--success">
                                    <v-icon size="22" color="success">mdi-currency-rupee</v-icon>
                                    ({{ report.amount }})
                                </v-col>

                                <v-col cols="6" md="6" class="text--warning">
                                    <v-icon size="22" color="warning">mdi-list-status</v-icon>
                                    {{ report.workStatusName }}
                                </v-col>
                            </v-row>


                        </v-container>
                    </v-card>
                </v-timeline-item>
                <v-timeline-item v-else
                                 :color="index % 2 === 0 ? 'purple lighten-2' : 'blue lighten-2'"
                                 style="padding-bottom:0px;padding-top:0px"
                                 left
                                 small>
                    <v-card class="custom-design">
                        <v-card-title class="custom-title" :style="getSubjectRowStyle(index)">
                            <span style="color:white">  {{index+1}}</span>
                            <v-icon dark
                                    size="42"
                                    class="mr-4">
                                mdi-calendar-month
                            </v-icon>
                            <h2 class="text-h6 white--text font-weight-bold">
                                {{report.monthName}} [ {{report.subsectionName}} ]
                            </h2>
                        </v-card-title>
                        <v-container :style="{ backgroundColor: report.colorCode }">

                            <v-row class="font-weight-bold">
                                <v-col cols="12">
                                    <v-icon size="22">mdi-pencil</v-icon>
                                    {{ report.remarks }}
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="6" md="6" class="text--success">
                                    <v-icon size="22" color="success">mdi-currency-rupee</v-icon>
                                    ({{ report.amount }})
                                </v-col>

                                <v-col cols="6" md="6" class="text--warning">
                                    <v-icon size="22" color="warning">mdi-list-status</v-icon>
                                    {{ report.workStatusName }}
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-timeline-item>
            </v-timeline>

        </v-container>
    </div>
</template>

<script>
    import {required} from "vuelidate/lib/validators";
    import axios from "axios";
    import {mapGetters} from "vuex";

    export default {
        name: 'ReportComponent',
        watch: {
            "logData": {
                handler: async function () {
                    this.$emit("logDataResponse", this.logData)
                },
                deep: true
            },
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            isSuperAdmin() {
                return this.userRole === "SuperAdmin"
            },
            isCompany() {
                return this.userRole === "Company"
            },
            isDepartment() {
                return this.userRole === "Department"
            },
            isBranch() {
                return this.userRole === "Branch"
            },
            isDepo() {
                return this.userRole === "Depo"
            },
            companyIDErrors() {
                const errors = [];
                if (!this.$v.logData.companyID.$dirty) return errors;
                !this.$v.logData.companyID.required &&
                errors.push("Company is required.");
                return errors;
            },
            yearErrors() {
                const errors = [];
                if (!this.$v.logData.year.$dirty) return errors;
                !this.$v.logData.year.required &&
                errors.push("Year is required.");
                return errors;
            },
        },
        props: ['companyData'],
        components: {
        },
        data() {
            return {
                props: {
                    row: {
                        isFinalized: false, // Initial value
                    },
                },
                expensesReport: [],
                dialogView: false,
                ShowReport: false,
                count: 1,
                budgetcount: 1,
                quartercount: 1,
                exportTbl:false,
                dialogApproved: false,
                dialogBudgetSendApproved: false,
                dialogQuarter: false,
                formModal: false,
                panelData: [0, 1],
                selectedStatus: {
                    company: "",
                    branch: ""
                },
                error: false,
                callbackResponse: {
                    timeout: 6000,
                    message: ""
                },
                listDDLData: {
                    companyList: [],
                    departmentList: [],
                    branchList: [],
                    depoList: []
                },
                status: {
                    isCompany: false,
                    isDepartment: false,
                },
                snackbar: false,
                table: false,
                dialogCreate: false,
                breadCrumbs: [],
                IsActive: false,
                TotalHeaderIndex: 0,
                rows: [],
                reportID: 0,
                reportTitle: "",
                totalRows: [],
                headers: [],
                colsHeaders: [],
                groupLevel: 0,
                totals: [],
                roleReportList: [],
                reportList: [],
                reportLogs: [],
                subColumns: [],
                showNextYear: false,
                yearList: [],
                tableFormData: [],
                helpData:[],
                approveData:[],
                logData: {
                    companyID: 0,
                    departmentID: 0,
                    branchID: 0,
                    depoID: 0,
                    reportID: 0,
                    year: "2081",
                    reportLogID: 0,
                    isActive: null
                },
                serverData: {
                    companyID: null,
                    departmentID: null,
                    branchID: null,
                    depoID: null,
                    reportID: parseInt(this.$route.params.id),
                    year: "",
                    reportLogID: 0
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "reportID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                role: this.$store.getters.getUserRole,
                userData: this.$store.getters.getUserData,
                yearShow: "",
                valueShow: "",
                setYearValue: "",
                setAllValue: "",
                submitStatus: "",
                YearPreviousCurrentNext: {},
                groupedRows: [],
                color: "",
                isLoadedFromServer: false,
                isShowReport: false,
                final: {
                    finalizedFormData: {}
                },
                currentFormApproved: true
              
            };
        },
        validations: {
            logData: {
                companyID: {required},
                year: {required},
            }
        },
        mounted() {
            this.loadCrumb()
        },

        methods: {
            reset() {
                this.logData = {
                    companyID: null,
                    departmentID: null,
                    branchID: null,
                    depoID: null,
                    reportID: 0,
                    year: "",
                    reportLogID: 0
                },
                    this.status = {
                        isCompany: false,
                        isDepartment: false,
                    }
                this.selectedStatus = {
                    company: "",
                    branch: ""
                }
                this.$nextTick(() => {
                    this.$v.$reset()
                })
            },
            dialogueClose() {
                this.formData = {}
                this.$emit('dialogueClose')
            },

            onFormResponse() {
                this.dialogView = false
            },

            LoadBudgetExpensesData() {
                this.dialogView = true
                this.logSendData = {
                    reportID: this.logData.reportID,
                    companyID: this.companyData.companyID,
                    branchID: this.companyData.branchID,
                    depoID: this.companyData.depoID,
                    fiscalYearID: this.logData.year
                }

                let param = {
                    reportID: parseInt(this.logData.reportID),
                    companyID: parseInt(this.companyData.companyID),
                    branchID: parseInt(this.companyData.branchID),
                    depoID: parseInt(this.companyData.depoID),
                    fiscalYearID: parseInt(this.logData.year)

                }
                axios.post("ReportSettings/GetParticularOfficeExpensesReportDataAsync", param).then(response => {
                    this.expensesReport = response.data
                }).catch(response => {
                    this.expensesReport = response.data
                });
            },

            loadCrumb() {
                axios.get("ReportSettings/GetReportYearList").then(response => {
                    this.yearList = response.data
                })

                axios.get('ReportSettings/DDLReportList').then(response => {
                    this.reportList = response.data
                })

                axios.get('Company/DDLCompanyList').then(response => {
                    this.listDDLData.companyList = response.data
                })
                axios.get("ReportSettings/GetRoleWiseReportList/" + this.userData.departmentID).then(response => {
                    this.roleReportList = response.data
                })
            },
            getSubjectRowStyle(subjectIndex) {
                const colors = ['#ba68c8', '#ffca28', '#26c6da', '#ef5350', '#66bb6a']; // Define the desired color codes
                const backgroundColor = colors[subjectIndex % colors.length];
                return `background-color: ${backgroundColor}; margin:auto`;
            },
        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }
    .dynamicTitle {
        font-size: 44px;
    }

    .tbl {

        th {
            padding-top: 12px;
            padding-bottom: 12px;
            text-align: left;
            background-color: $main-color;
            color: white;
        }
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        table-layout: fixed;
        border-collapse: collapse;
        width: 100%;

    }

    th, td {
        padding: 15px;
    }

    .tfoot {
        background-color: #d2d2d2;
    }

    .data-input {
        .v-input {
            max-width: 7.1em !important;
        }
    }

    input {
        max-width: 5.7em !important;
    }

    .employee-form-header {
        text-align: center;
        background-color: $main-color;
        height: 3em;
        padding: .6em;

        span {
            color: #ffffff;
            font-size: 1.4em;
        }
    }

    #form_card {
        text-align: center;

    }

    .box-border {
        border: 1px solid;
        padding: 1em;
    }
.sticky-table-header{
  thead{
    position: sticky;
    top: 60px;
    z-index: 1;
  }
}
    .custom-design {
        transition: transform 0.2s, box-shadow 0.2s; /* Add box-shadow to the transition */
        cursor: pointer;
        box-shadow: 0 0 0 transparent; /* Start with no shadow */
    }

    .custom-design:hover {
        transform: scale(1.02);
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3); /* Add a shadow on hover */
    }

    .custom-design h3,
    .custom-design p {
        font-size: 12px;
        margin: 5px 0;
    }

    .custom-title {
        padding: 5px;
    }
</style>
